var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag",on:{"click":function($event){return _vm.$emit('on-remove')}}},[_c('div',{staticClass:"content"},[_c('p',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.name)+" "),_c('span',[_vm._v("("+_vm._s(_vm.apmid)+")")])])]),_c('div',{staticClass:"close-icon"},[_c('Icon',{attrs:{"size":"24","name":"times-circle"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }